import * as React from "react"
import { cn } from "../../lib/cn"

export function DisplayText({ className, children, ...props }: React.HTMLAttributes<HTMLHeadingElement>) {
    return (
        <h1 className={cn("text-3xl font-semibold leading-[1.2] text-text-primary", className)} {...props}>
            {children}
        </h1>
    )
}

export function PageTitle({ className, children, ...props }: React.HTMLAttributes<HTMLHeadingElement>) {
    return (
        <h1 className={cn("text-[28px] font-semibold leading-[1.25] text-text-primary", className)} {...props}>
            {children}
        </h1>
    )
}

export function SectionTitle({ className, children, ...props }: React.HTMLAttributes<HTMLHeadingElement>) {
    return (
        <h2 className={cn("text-[22px] font-semibold leading-[1.3] text-text-primary", className)} {...props}>
            {children}
        </h2>
    )
}

export function SubsectionTitle({ as: Comp = 'h3', className, children, ...props }: React.HTMLAttributes<HTMLHeadingElement> & { as?: React.ElementType }) {
    return (
        <Comp className={cn("text-xl font-medium leading-[1.35] text-text-primary", className)} {...props}>
            {children}
        </Comp>
    )
}

type BodyTextProps = React.HTMLAttributes<HTMLParagraphElement> & {
    prose?: boolean
}

export function BodyText({ className, prose, children, ...props }: BodyTextProps) {
    return (
        <p className={cn("text-base font-normal leading-[1.6] text-text-primary", prose && "max-w-[70ch]", className)} {...props}>
            {children}
        </p>
    )
}

type MetaTextProps = React.HTMLAttributes<HTMLSpanElement> & {
    prose?: boolean
}

export function MetaText({ className, prose, children, ...props }: MetaTextProps) {
    return (
        <span className={cn("text-sm font-normal leading-[1.5] text-text-muted", prose && "max-w-[70ch]", className)} {...props}>
            {children}
        </span>
    )
}

export function CaptionText({ className, children, ...props }: React.HTMLAttributes<HTMLSpanElement>) {
    return (
        <span className={cn("text-xs font-normal leading-[1.4] text-text-muted", className)} {...props}>
            {children}
        </span>
    )
}

export function LabelText({ className, children, ...props }: React.HTMLAttributes<HTMLLabelElement>) {
    return (
        <label className={cn("text-sm font-medium leading-none text-text-primary", className)} {...props}>
            {children}
        </label>
    )
}
